import Container from '@/components/Container';
import EventBreadcrumb from '@/domain/Event/EventBreadcrumb';
import EventDateInfo from '@/domain/Event/EventDateInfo';
import EventExcerpt from '@/domain/Event/EventExcerpt';
import EventContent from '@/domain/Event/EventContent';
import EventPanelInfo from '@/domain/Event/EventPanelInfo';
import EventPhotoGallery from '@/domain/Event/EventPhotoGallery';
import client from '@/api/client';
import { eventQuery, eventSlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: eventQuery,
    variables: {
      id: params.slug,
    },
  });

  return {
    props: {
      event: data.event,
    }
  }
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: eventSlugsQuery });

  const paths = data?.events?.nodes?.map(({ slug }) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false,
  };
}

export default function Event({
  event,
  isNotAPastEvent,
}) {
  const hasExcerpt = !!event.excerpt && event.excerpt !== '';
  const hasGallery = !!event.gallery?.images;
  const categories = event.eventTypes?.nodes || [];

  return (
    <div className="pt-10 pb-12 lg:pb-20 bg-gradient-to-b from-white to-gray-100">
      <Container className="space-y-4 lg:space-y-6">
        <EventBreadcrumb categories={categories} />
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-8">
            <div className="flex flex-col space-y-4">
              <h1 className="font-medium text-xl lg:text-4xl lg:font-bold tracking-tight">
                {event.title}
              </h1>
              <EventDateInfo publishDate={event.date} dates={event.info.dates} />
              <div className="flex flex-col space-y-6">
                {hasExcerpt && (<EventExcerpt excerpt={event.excerpt} />)}
                <EventContent content={event.content} />
              </div>
            </div>
          </div>
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32 space-y-10">
              {isNotAPastEvent && (<EventPanelInfo info={event.info} />)}
              {hasGallery && (<EventPhotoGallery event={event.title} uri={event.uri} gallery={event.gallery} />)}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
